export default __webpack_public_path__ + "static/media/footerQR.ce446baf.png";